
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

//import loadComponents from 'gia/loadComponents';
import config from 'gia/config';


import Lenis from '../components/lenis';
import loadComponents from 'gia/loadComponents';


import Loader from './loader';
import Highway from './highway';
import CustomRenderer from './custom-renderer';
import ProjectRenderer from './project-renderer';
import CustomTransition from './custom-transition';
import DefaultTransition from './default-transition';



class App {

  constructor($) {
    this.create()
  }

  create() {

 
    window.lenis = new Lenis()
    lenis.on('scroll', ScrollTrigger.update)
   // config.set('log', false);


    gsap.ticker.add((time) => {
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)


    const H = window.H = new Highway.Core({
      renderers: {
        home: ProjectRenderer,
        people: CustomRenderer,
        gift: CustomRenderer,
        faq: CustomRenderer,
        news: CustomRenderer,
        article: CustomRenderer
      },
      transitions: {
        default: DefaultTransition,
        home: CustomTransition
      }
    });

    function activateScripts(container) {
      const scripts = container.querySelectorAll('script');
      scripts.forEach(oldScript => {
        const newScript = document.createElement('script');
        // Copy attributes
        Array.from(oldScript.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });
        // Copy inline code
        newScript.textContent = oldScript.textContent;
        // Replace old script with new
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    }

    H.on('NAVIGATE_END', ({
      to,
      trigger,
      location
    }) => {

      activateScripts(to.view)

      if (location.anchor) {

        lenis.scrollTo(location.anchor, {
          lerp: 0.33
        })
      }
    });

   
    const  loader = document.getElementById('loader')

    loadComponents({Loader:Loader},  loader )

const links = document.querySelectorAll('.menu a');


    //Listen the `NAVIGATE_IN` event
   // This event is sent everytime a `data-router-view` is added to the DOM Tree
    H.on('NAVIGATE_IN', ({
      to,
      location
    }) => {
      // Check Active Link
      for (let i = 0; i < links.length; i++) {
        const link = links[i];

        // Clean class
        link.classList.remove('is-active');
        // Active link
        if (link.href === location.href) {
          link.classList.add('is-active');
        }
      }
    });




   

  }


}

module.exports = App
